import PropTypes from 'prop-types';

import { TypeChecker, withInfo } from './util';

function list(...args: any[]): TypeChecker {
  // @ts-ignore
  return PropTypes.array(...args);
}

export default withInfo(list, {
  type: 'list',
  group: 'network',
});
